export interface SubscriptionTier {
  value: string;
  label: string;
}

export const SUBSCRIPTION_TIERS: ReadonlyArray<SubscriptionTier> = [
  { value: 'classic', label: 'Classic' },
  { value: 'classic plus', label: 'Classic Plus' },
  { value: 'custom', label: 'Custom' },
  { value: 'neca classic', label: 'NECA Classic' },
  { value: 'neca lite', label: 'NECA Lite' },
  { value: 'nimblesafe', label: 'NimbleSafe' },
];
